import { Injectable, NgModule } from '@angular/core'
import { CoreService } from '@core/core.service'
import { Project } from '@data/model/project.model'
import { Store } from '@ngrx/store'
import { Observable } from 'rxjs'
import { getProject } from './data/store/stage/stage.selectors'

@Injectable()
export class AppService {
   console: boolean = this.core.modeDevel
   logPrefix: string = '@app - ' + this.constructor.name

   public tmpData: any = {}

   constructor(
      public core: CoreService,
      private _store: Store
   ) {}

   setupLayoutAndTableElements() {
      if (this.console) console.log(this.logPrefix, 'setup')

      this.core.stage.addLayoutTheme('DEFAULT', {
         spinnerType: 'PNO',
         topbarLogo: '/assets/images/pmp-new-logo.svg',
      })

      this.core.stage.addLayoutTheme('B4R', {
         spinnerType: 'B4R',
         topbarLogo: '/assets/images/PMP-logo-B4R.svg',
         topbarLogoLink: 'SITE_URL_B4R',
      })

      this.core.stage.addLayoutTheme('SHYPS', {
         spinnerType: 'SHYPS',
         topbarLogo: '/assets/images/PMP-logo-SHYPS.svg',
         partnersRolesLegend: true,
      })

      this.core.stage.addLayoutTheme('SPINE', {
         spinnerType: 'PNO',
         topbarLogo: '/assets/images/PMP-logo-SPINE.svg',
         topbarLogoLink: 'SITE_URL_SPINE',
      })

      this.core.stage.addLayoutTheme('D4IF', {
         spinnerType: 'PNO',
         topbarLogo: '/assets/images/PMP-logo-D4IF.svg',
      })

      this.core.stage.addLayoutTheme('C4B', {
         spinnerType: 'PNO',
         topbarLogo: '/assets/images/PMP-logo-C4B.svg',
      })

      this.core.stage.addLayoutTheme('BINS', {
         spinnerType: 'BINS',
         topbarLogo: '/assets/images/PMP-logo-BINS.svg',
         topbarLogoLink: 'SITE_URL_BINS',
      })

      // Store tables
      this.initStoreTables()
   }

   layoutThemeCheck() {
      if (this.console) console.log(this.logPrefix, 'layoutThemeCheck')

      var projectId = this.getCurrentProjectId()

      if (projectId && projectId == this.core.config.B4R_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('B4R')
      } else if (projectId && projectId == this.core.config.SHYPS_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('SHYPS')
      } else if (projectId && projectId == this.core.config.SPINE_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('SPINE')
      } else if (projectId && projectId == this.core.config.D4IF_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('D4IF')
      } else if (projectId && projectId == this.core.config.C4B_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('C4B')
      } else if (projectId && projectId == this.core.config.BINS_PROJECT_ID?.toString()) {
         this.core.stage.applyLayoutTheme('BINS')
      } else {
         $app.core.stage.defaultLayoutTheme()
      }
   }

   logout() {
      $app.core.auth.keycloakAngular.logout()
   }

   //-- Theme --//

   getCurrentProjectId() {
      if (this.console) console.log(this.logPrefix, 'getCurrentProjectId')
      return sessionStorage.getItem('currentProjectId')
   }

   getCurrentProject(): Observable<Project> {
      if (this.console) console.log(this.logPrefix, 'getCurrentProject')

      return this._store.select(getProject)
   }

   getEventCategories() {
      var storeReply = this.core.store.getData('eventCategories')

      return !storeReply.error ? storeReply.result : []
   }

   getEventCategory(categoryId: number) {
      for (let category of this.getEventCategories()) {
         if (category.id == categoryId) {
            return category
            break
         }
      }

      return null
   }

   getEventCategoryGroup(categoryId: number) {
      for (let category of this.getEventCategories()) {
         if (category.id == categoryId) {
            return category.group
            break
         }
      }

      return 0
   }

   getEventCategoryGroups() {
      let groups = []
      for (let category of this.getEventCategories()) {
         if (!groups.includes(category.group)) groups.push(category.group)
      }

      return groups
   }

   getDataState() {
      if (this.console) console.log(this.logPrefix, 'getDataState')

      return {
         noData: true,
         loading: false,
         error: false,
         filtered: false,
      }
   }

   //-- Store Tables data --//

   initStoreTables() {
      var storeReply = this.core.store.setData('StoreTables', {})
      return !storeReply.error
   }

   getStoreTables() {
      var storeReply = this.core.store.getData('StoreTables')
      return !storeReply.error ? storeReply.result : null
   }

   hasStoreTable(dataRef: string) {
      var storeReply = this.core.store.hasData('StoreTables/' + dataRef)
      return storeReply.result
   }

   setStoreTable(dataRef: string, data: any) {
      var storeReply = this.core.store.setData('StoreTables/' + dataRef, data)
      return !storeReply.error
   }

   getStoreTable(dataRef: string) {
      var storeReply = this.core.store.getData('StoreTables/' + dataRef)
      return !storeReply.error ? storeReply.result : null
   }

   clearStoreTable(dataRef: string) {
      var storeReply = this.core.store.removeData('StoreTables/' + dataRef)
      return storeReply.result
   }

   clearStoreTableByPrefix(dataPrefix: string) {
      var storeTables = this.getStoreTables()
      for (let dataRef in storeTables) {
         if (dataRef.startsWith(dataPrefix)) this.clearStoreTable(dataRef)
      }
   }
}

//-- CORE: AppService Global Ref --//

export let $app: AppService

@NgModule({
   providers: [AppService],
})
export class AppServiceModule {
   constructor(public appService: AppService) {
      $app = this.appService
   }
}

